export default "<div [innerHtml]= \"htmlContent\"></div>\r\n";